import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: '',
    oneOf: '',
  },
  string: {
    email: '',
  },
});

const formSchemaCreation = Yup.object().shape({
  companyName: Yup.string().required(),
  website: Yup.string().required(),
  facebookBusinessManagerID: Yup.string().required(),
  facebookUrl: Yup.string().required(),
  region: Yup.string().required(),
  estimatedMonthlyMessagesVolume: Yup.string().required(),
  businessVertical: Yup.string().required(),
  brandName: Yup.string().required(),
  address: Yup.string().required(),
  businessDescription: Yup.string().notRequired(),
  aboutInfo: Yup.string().required(),
  contactEmail: Yup.string().email().notRequired(),
  imageUrl: Yup.string().notRequired(),
  agreeToTerms: Yup.boolean().required().oneOf([true]),
});

const formSchemaEdit = Yup.object().shape({
  imageUrl: Yup.string().notRequired(),
  brandName: Yup.string().required(),
  aboutInfo: Yup.string().required(),
  contactEmail: Yup.string().email().notRequired(),
  address: Yup.string().required(),
  businessDescription: Yup.string().required(),
  agreeToTerms: Yup.boolean().required().oneOf([true]),
});

export { formSchemaCreation, formSchemaEdit };
